import script from "./AdministratorProjectManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectManagement.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectManagement.vue?vue&type=style&index=0&id=7fca779a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fca779a"]])

export default __exports__